import EventsPrimary from '@sma/components/device/events';

export default EventsPrimary;
